"use strict";

var _globals = require("@insided/shared/utils/globals");

define(['app', 'jquery'], function (app, $) {
  return app.Marionette.ItemView.extend({
    template: false,
    // Function when subscribe button is clicked
    clickedButton: function clickedButton(e) {
      e.preventDefault(); // Setting the button as a var and set it to loading for feedback

      var thisFavBtn = this.$el;
      thisFavBtn.addClass('is--loading'); // Check if the user is subscribed to the topic and unsuscribe through ajax and remove the loading and active state

      if (thisFavBtn.hasClass('is--active')) {
        $.ajax({
          url: (0, _globals.getSubfolderPrefix)() + '/favorite/delete',
          data: {
            subscribethreadid: $('.subscribethreadid').val(),
            yip_csrf_token: $('#csrftoken').val()
          },
          type: 'post',
          success: function success() {
            thisFavBtn.removeClass('is--active');
            thisFavBtn.removeClass('is--loading');
          }
        });
      } else {
        // if the user is not subscribed to the topic, subscribe through ajax, remove the loading and add active state
        $.ajax({
          url: (0, _globals.getSubfolderPrefix)() + '/favorite/new',
          data: {
            threadid: $('#threadid').val(),
            yip_csrf_token: $('#csrftoken').val()
          },
          type: 'post',
          success: function success(data) {
            $('.subscribethreadid').val($.trim(data));
            thisFavBtn.addClass('is--active');
            thisFavBtn.removeClass('is--loading');
          }
        });
      }
    },
    // Call on the click function of the subscribe button
    onRender: function onRender() {
      var self = this;
      this.$el.on('click', function (e) {
        self.clickedButton(e);
      });
    }
  });
});